import { motion } from "framer-motion";
import { Map, Target, LayoutGrid, GraduationCap, Radio, Users } from "lucide-react";

const icons = [Map, Target, LayoutGrid, GraduationCap, Radio, Users];

export const WhyGta = ({ t }) => (
  <section id="why" data-testid="why-section" className="py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7 }}
        className="max-w-3xl"
      >
        <p className="font-mono-num text-xs uppercase tracking-[0.3em] text-[#EAB308]">{t.why.eyebrow}</p>
        <h2 className="mt-4 text-4xl font-extrabold sm:text-5xl">{t.why.headline}</h2>
        <p className="mt-4 text-base text-gray-400 md:text-lg">{t.why.sub}</p>
      </motion.div>

      <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {t.why.items.map((c, i) => {
          const Icon = icons[i];
          return (
            <motion.div
              key={i}
              data-testid={`why-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.1 }}
              className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[#0C1732] p-8 transition-[border-color,transform] duration-300 hover:-translate-y-1.5 hover:border-[#EAB308]/40"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#2847C8]/25 transition-colors duration-300 group-hover:bg-[#2847C8]/40">
                <Icon className="h-6 w-6 text-[#8FA8FF]" />
              </div>
              <h3 className="mt-6 text-lg font-bold">{c.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-gray-400">{c.text}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
